'use client'
import React from 'react';
import Image from 'next/image'

import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

interface ImageCarouselProps {
  items: Object[];
}

const ImageCarousel: React.FC<ImageCarouselProps> = ({ 
  items 
}) => {
  var settings = {
    dots: true,
    infinite: true,
    adaptiveHeight: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="mb-2">
      <Slider {...settings}>
        {items.map((item:any) => {
          if(item.url.includes('.bmp')) { return null }
          const url = `${item.url}?w=1200&h=600&fit=fill&fm=webp` || null
          if(!url) { return null }
          return <div key={item.sys.id}><Image src={url} width={1200} height={600} alt="" /></div>
        })}
      </Slider>
    </div>
  );
}

export default ImageCarousel;